import { render, staticRenderFns } from "./MyChannelsList.vue?vue&type=template&id=4c5f79c2&scoped=true"
import script from "./MyChannelsList.vue?vue&type=script&lang=js"
export * from "./MyChannelsList.vue?vue&type=script&lang=js"
import style0 from "./MyChannelsList.vue?vue&type=style&index=0&id=4c5f79c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f79c2",
  null
  
)

export default component.exports